<template>
    <button class="badge bg-danger m-1" @click="deleteCategory">delete</button>
</template>

<script>
export default {
    name: "DeleteChildCategory",

    data() {
        return {
            form: new Form(this.element)
        };
    },
    props: {
        element: {}
    },
    methods: {
        deleteCategory(){
            this.form.delete('/categories/' + this.element.id)
                .then(response =>  this.$emit('deleteCategory', this.element))
        }
    }

}
</script>

<style scoped>

</style>
